/* eslint-disable no-unused-vars */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-undef */
/* eslint-disable react-native/no-inline-styles */
import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Pressable,
} from 'react-native';
// import Image from '@web/components/common/Image';
// import { Avatar } from 'react-native-elements-light';
import { imageCdn, formatDate } from '~global/helpers';
import { useSelector, useDispatch } from 'react-redux';
import Carousel from '@web-components/common/Carousel';
import { carouselSlide } from '~assets/styles/carouselStyles';
import { isWeb, isMobileWeb, isNative } from '~global/screens';
import ModalizeBase from '@web-components/modals/ModalizeBase';
import Colors from '~global/Colors';
const ResponsiveImage = React.lazy(() =>
  import('@universal-components/ResponsiveImage'),
);
import Arrow from '@web-components/common/carousels/Arrow';
import WithLocalSvg from '@web-components/common/WithLocalSvg';
const ModalUserPhotos = (props) => {
  const dispatch = useDispatch();
  // const { defaultAvatarSource } = global;
  // eslint-disable-next-line no-unused-vars
  const {
    data: { userPhotos, photo, index },
    isShow,
  } = useSelector((state) => state.modal.userPhotos);
  const modalizeRef = useRef(null);
  // const carouselRef = useRef(null);
  const [navImage, setNavImage] = useState(null);
  const [navPagination, setNavPagination] = useState(null);
  const [selectedIndexImage, setIndexImage] = useState(0);
  const [selectedImageUser, setSelectedImageUser] = useState(null);
  const userReviewData = selectedImageUser ? selectedImageUser : photo;
  // eslint-disable-next-line no-unused-vars

  useEffect(() => {
    if (photo) {
      setIndexImage(index);
    }
  }, [photo]);
  useEffect(() => {
    if (isShow) {
      modalizeRef.current?.open();
    } else {
      modalizeRef.current?.close();
    }
  }, [isShow]);

  const closeModal = () => {
    setSelectedImageUser(null);
    dispatch({ type: 'MODAL/HIDE', modalName: 'userPhotos', data: [] });
  };

  const imageSource = (image, width = 100) => {
    return imageCdn({ config: `w=${width}`, image });
  };

  const settingsImage = {
    initialSlide: index,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: navPagination,
    arrows: isWeb ? true : false,
    afterChange: function (index) {
      setIndexImage(index);
      setSelectedImageUser(userPhotos[index]);
    },
    prevArrow: <Arrow.ArrowLeft customStyle={styles.arrowParentLeftCarousel} />,
    nextArrow: (
      <Arrow.ArrowRight customStyle={styles.arrowParentRightCarousel} />
    ),
  };

  const settingsPagination = {
    asNavFor: navImage,
    slidesToShow: isWeb ? 7 : 4,
    slidesToScroll: 4,
    centerMode: false,
    initialSlide: index,
    dots: false,
    infinite: false,
    focusOnSelect: true,

    nextArrow: <Arrow.ArrowRight customStyle={styles.arrowRightCarousel} />,
    prevArrow: <Arrow.ArrowLeft customStyle={styles.arrowLeftCarousel} />,
  };

  return (
    <ModalizeBase
      ref={modalizeRef}
      handleStyle={styles.handleStyle}
      onClose={closeModal}>
      <View style={styles.modalStyle}>
        <View
          style={{
            alignItems: 'center',
          }}>
          <View style={styles.modalChildContainer}></View>
        </View>

        <View style={styles.container} pointerEvents={'auto'}>
          <View style={[styles.rowSpaceBetween, { padding: 15 }]}>
            <Text style={styles.title}>
              User Photos ({(userPhotos || []).length})
            </Text>
            <Pressable onPress={closeModal}>
              <WithLocalSvg
                width={14}
                height={14}
                asset={require('~assets/img/product/icon-close.svg')}
              />
            </Pressable>
          </View>
        </View>
        {isWeb && userReviewData && (
          <View style={[styles.rowSpaceBetween, { padding: 1 }]}>
            <View style={!isNative && styles.avatarWrapper}>
              <View style={{ flexDirection: 'row', padding: 5 }}>
                {/* <Avatar
                rounded
                size="medium"
                source={
                  userReviewData?.user?.image
                    ? {
                      uri: imageSource(userReviewData.user.image, 100),
                    }
                    : require('~assets/img/profile/bg-header-user-profile-page.png')
                }
              /> */}

                <View
                  style={{
                    justifyContent: 'space-around',
                    marginLeft: 16,
                  }}>
                  <Text style={styles.labelButton}>
                    {userReviewData?.user?.name}{' '}
                  </Text>
                  <Text style={styles.ageRange}>
                    {formatDate(userReviewData?.created_at)} ·{'  '}
                    {userReviewData?.user?.age_range}
                  </Text>
                </View>
              </View>
            </View>
            <View>
              <Text style={styles.sliderHeaderIndexText}>
                {selectedIndexImage + 1} of {userPhotos?.length} photos
              </Text>
            </View>
          </View>
        )}

        <View style={styles.borderLineTop} />
        <View styles={styles.imagesContainer}>
          <Carousel {...settingsImage} innerRef={setNavImage}>
            {(userPhotos || []).map((item, index) => (
              <View style={styles.imageContainer} key={`imageProduct${index}`}>
                <TouchableOpacity
                  style={[carouselSlide, styles.carouselSlide]}
                  key={`item${index}`}>
                  <ResponsiveImage
                    source={{
                      uri: imageSource(item.image_url, 400),
                    }}
                    style={{
                      height: isWeb ? 328 : 255,
                      borderRadius: 8,
                      ...(isMobileWeb && { maxWidth: 270 }),
                    }}
                  />
                </TouchableOpacity>
              </View>
            ))}
          </Carousel>
          <View style={styles.borderLineBottom} />
          {!isNative && (
            <View style={styles.imagePaginationWrapper}>
              <Carousel {...settingsPagination} innerRef={setNavPagination}>
                {(userPhotos || []).map((item, index) => (
                  <TouchableOpacity
                    activeOpacity={0.8}
                    style={styles.imageContainer}
                    key={`imageProduct${index}`}
                    onPress={() => {
                      setIndexImage(index);
                      setSelectedImageUser(item);

                      try {
                        navImage?.slickGoTo(index);
                      } catch (err) {}
                    }}>
                    <ResponsiveImage
                      source={{
                        uri: imageSource(item.image_url, 400),
                      }}
                      style={{
                        ...(isWeb && {
                          height: 66,
                          maxWidth: 70,
                          minWidth: 70,
                        }),
                        borderRadius: 8,
                        borderWidth: 2,
                        borderColor:
                          selectedIndexImage === index
                            ? Colors.purple4
                            : Colors.grey0,
                        ...(isMobileWeb && {
                          maxWidth: 73,
                          minWidth: 73,
                          height: 70,
                          marginRight: 10,
                        }),
                      }}
                      resizeMode="cover"
                    />
                  </TouchableOpacity>
                ))}
              </Carousel>
            </View>
          )}
        </View>
      </View>
    </ModalizeBase>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },

  arrowParentLeftCarousel: {
    ...(isWeb && { cursor: 'pointer' }),
    height: 46,
    width: 47,
    left: 15,
  },
  arrowParentRightCarousel: {
    ...(isWeb && { cursor: 'pointer' }),
    height: 46,
    width: 47,
    right: 20,
  },

  modalChildContainer: {
    top: 10,
    backgroundColor: Colors.grey0,
    height: 3,
    width: 38,
    zIndex: 1,
  },
  ageRange: {
    fontFamily: 'figtree-medium',
    color: '#6F6F6F',
    ...(isWeb
      ? {
          fontSize: 12,
          lineHeight: 16,
        }
      : {
          fontSize: 11,
          lineHeight: 14,
          marginLeft: 4,
        }),
  },
  labelButton: {
    fontFamily: 'figtree-bold',
    fontSize: 15,
    lineHeight: 18,
  },
  arrowLeftCarousel: {
    ...(isWeb && { cursor: 'pointer' }),
  },
  avatarWrapper: {
    marginLeft: 12,
  },
  arrowRightCarousel: {
    ...(isWeb && { cursor: 'pointer' }),
    right: 14,
  },

  title: {
    color: '#25182E',
    fontSize: 17,
    fontFamily: 'figtree-black',
    lineHeight: 22,
  },
  rowSpaceBetween: {
    justifyContent: 'space-between',

    alignItems: 'center',
    flexDirection: 'row',
  },
  imagePaginationWrapper: {
    top: 5,
    marginBottom: 20,
    ...(isWeb && { cursor: 'pointer' }),
  },
  imagesContainer: {
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 6,
  },
  imageContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  carouselSlide: {
    height: 'auto',
    alignItems: 'center',
    paddingTop: 6,
    paddingBottom: 4,
    paddingHorizontal: 15,
  },
  handleStyle: {
    top: 26,
    backgroundColor: isWeb ? 'transparent' : '#D7CDF5',
    height: 3,
    width: 38,
  },
  modalStyle: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    padding: 20,
    overflow: 'hidden',
    ...(isWeb
      ? {
          width: 750,
          margin: 'auto',
          borderRadius: 8,
        }
      : {}),
  },
  borderLineBottom: {
    borderWidth: 1,
    borderColor: Colors.grey0,
    marginTop: 14,
    marginBottom: 25,
  },
  borderLineTop: {
    borderWidth: 1,
    borderColor: Colors.grey0,
    marginTop: 14,
    marginBottom: 25,

    marginHorizontal: 10,
  },

  sliderHeaderIndexText: {
    fontFamily: 'figtree-bold',
    fontSize: 15,
    lineHeight: 14,
    marginRight: 20,
    color: 'grey',
  },
});

export default ModalUserPhotos;
